import Icon from "@/components/base/Icon"
import CustomTooltip from "@/components/base/Tooltip"
import ErrorMessage from "@/components/features/business/error-message"
import useBusinessLogic from "@/hooks/businesses/useBusinessLogic"
import useMainInfoStore from "@/store/overview/main-info/useMainInfoStore"
import { Box, IconButton, Paper, Typography } from "@mui/material"
import classNames from "classnames"
import { useTranslation } from "react-i18next"
import OverviewTitle from "../title"
import useStyles from "./styles"

const OverviewContact = ({ isLoading, mandatoryCheck = false, sx }) => {
    const { classes } = useStyles()
    const { t } = useTranslation()
    const { navigateTo } = useBusinessLogic()
    const { address, name, logo, id, isAddressVisible, companyName, phone } = useMainInfoStore()

    return (
        <Paper
            elevation={1}
            className={classNames("section clickable", classes.overviewContact)}
            onClick={() => !isLoading && navigateTo("edit-main-info")}
            id="mainInfo"
            sx={sx}
            data-e2e="main-info"
            data-testid="main-info"
        >
            <OverviewTitle
                title={t("USERS.MAIN_INFO")}
                icon="annotationInfo"
                tooltipText={t("BUSINESSES.EDIT_GENERAL.MAIN_TOOLTIP")}
            />
            <Box className="image-container">
                {name && !logo && (
                    <Box className="image-frame without-logo" data-e2e="without-logo">
                        <Icon name="imagePlaceholder" />
                        <Typography component="span">Logo</Typography>
                    </Box>
                )}
                {logo && (
                    <Box className="image-frame image-preview" data-e2e="with-logo">
                        <img src={logo} alt="Logo" />
                    </Box>
                )}
                <Box className="contact-wrapper">
                    {id && mandatoryCheck && <ErrorMessage />}
                    {name && (
                        <Box className="title-wrapper">
                            <Icon name="profile" />
                            <Typography variant="h3" data-testid="business-name">
                                {name}
                            </Typography>
                        </Box>
                    )}
                    {companyName && (
                        <Box className="line-wrapper">
                            <Icon name="building" />
                            <Typography component={"span"} data-testid="business-company">
                                {companyName}
                            </Typography>
                        </Box>
                    )}
                    {address && (
                        <Box className="line-wrapper address">
                            <Box>
                                <Icon name="map" />
                                <Typography component={"span"} data-testid="business-address">
                                    {address}
                                </Typography>
                            </Box>
                            <CustomTooltip
                                title={
                                    isAddressVisible
                                        ? t("BUSINESSES.ADDRESS.VISIBLE_TOOLTIP")
                                        : t("BUSINESSES.ADDRESS.HIDDEN_TOOLTIP")
                                }
                            >
                                <IconButton>
                                    <Icon
                                        data-testid="business-visibility-address"
                                        name={isAddressVisible ? "eye" : "eyeOff"}
                                    />
                                </IconButton>
                            </CustomTooltip>
                        </Box>
                    )}

                    {phone && (
                        <Box className="line-wrapper">
                            <Icon name="phone" />
                            <Typography component={"span"} data-testid="business-phone">
                                {phone}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Paper>
    )
}

export default OverviewContact
